import React, { useCallback, useContext } from 'react'
import produce from 'immer'
import * as Icon from '@desenvolvimento-intuix/ui-icons'
// eslint-disable-next-line no-unused-vars
import { IInputOnChange, Input } from '@desenvolvimento-intuix/ui-form'
import { Dropdown } from '@desenvolvimento-intuix/ui-grid-system'

import { TableContext } from '../../contexts/table'

import { Container, Column } from './styles'

export const Filter: React.FC = () => {
  const { columns, currentColumns, setCurrentColumns } =
    useContext(TableContext)

  const isSelected = useCallback(
    (data: string) => {
      return currentColumns.includes(data)
    },
    [currentColumns]
  )

  const onToggle: IInputOnChange = (name) => {
    const nextState = produce(currentColumns, (draftState) => {
      if (draftState.includes(name)) {
        if (draftState.length === 1) return

        draftState.splice(draftState.indexOf(name), 1)
        return
      }

      draftState.push(name)
    })

    setCurrentColumns(nextState)
  }

  return (
    <Container className='table-filter'>
      <Dropdown
        toggle={
          <button type='button'>
            <Icon.Filter />
          </button>
        }
      >
        <ul>
          {columns.map(({ data, title }) => (
            <li key={data}>
              <Column>
                <Input
                  {...{
                    label: title,
                    name: data,
                    type: 'checkbox',
                    value: data,
                    checked: isSelected(data),
                    onChange: onToggle
                  }}
                />
              </Column>
            </li>
          ))}
        </ul>
      </Dropdown>
    </Container>
  )
}
